const Divider = () => {
    return (
        <div className="dividerFullWidth">
        </div>
    );
}

export default Divider;